var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.625C0 3.31129 2.68629 0.625 6 0.625H34C37.3137 0.625 40 3.31129 40 6.625V34.625C40 37.9387 37.3137 40.625 34 40.625H6C2.68629 40.625 0 37.9387 0 34.625V6.625Z",
    fill: "#C4F538",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8332 28.4115V23.4115M23.3332 25.9115H28.3332M28.3332 19.2448H11.6665M28.3332 20.9115V17.7448C28.3332 16.8114 28.3332 16.3447 28.1515 15.9881C27.9917 15.6745 27.7368 15.4196 27.4232 15.2598C27.0666 15.0781 26.5999 15.0781 25.6665 15.0781H14.3332C13.3998 15.0781 12.933 15.0781 12.5765 15.2598C12.2629 15.4196 12.0079 15.6745 11.8482 15.9881C11.6665 16.3447 11.6665 16.8114 11.6665 17.7448V24.0781C11.6665 25.0115 11.6665 25.4783 11.8482 25.8348C12.0079 26.1484 12.2629 26.4033 12.5765 26.5631C12.933 26.7448 13.3997 26.7448 14.3332 26.7448H19.9998",
    stroke: "#C4F538",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyIcon);
export default __webpack_public_path__ + "static/media/buy-icon.2815b0210f15eb57c4e76d9e4461628f.svg";
export { ForwardRef as ReactComponent };